import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'vex-download-ebook',
  templateUrl: './download-ebook.component.html',
  styleUrls: ['./download-ebook.component.scss']
})
export class DownloadEbookComponent implements OnInit {
  isLinkValid: boolean = false;
  ebookMap: any = {
    "EBOOKINFIAMMAZIONE": { name: 'Guida_pratica_sull_infiammazione.pdf', url: 'https://storage.googleapis.com/ondemand_pdf/Ebook%20Guida%20pratica%20infiammazione.pdf' }
  }
  ebookId: string;
  isDownloading: boolean = false;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.isDownloading = false;
      const q = params['q'];

      if (!q) return this.isLinkValid = false;

      const parts = q.split('_ITS');

      this.ebookId = parts[0];
      let unix = parts[1] || '';
      unix = unix.replace('EXP', '');
      this.isValidLink(unix);
    });
  }

  isValidLink(unix: string) {
    const expiryDate = moment.unix(Number(unix)).add(5, 'days');

    const now = moment();
    this.isLinkValid = now.isBefore(expiryDate);
  }

  download(): void {
    if (!this.ebookId) return;

    const ebook = this.ebookMap[this.ebookId];
    if (!ebook?.url) return;
    this.isDownloading = true;

    fetch(ebook.url)
      .then(res => res.blob())
      .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = ebook.name || 'ebook';

        a.click();

        window.URL.revokeObjectURL(blobUrl);
      })
      .catch(err => {
        console.error('Errore download', err);
      });
  }

}
